module.exports = __webpack_public_path__ + "static/media/Synth-Pop-Small-01.51ac7229.m4a";